import React from 'react';
import { useIntl } from 'react-intl';
import Chip from '@mui/material/Chip';

const AccountsCountChipRenderer: React.FC<{ value: number }> = ({ value }) => {
  const { formatMessage } = useIntl();
  return (
    <Chip
      label={formatMessage(
        { id: 'beneficiary.accounts.count', defaultMessage: '{count} {count, plural, one {account} other {accounts}}' },
        { count: value ?? 0 },
      )}
      size="small"
      variant="outlined"
      color="primary"
    />
  );
};

export default AccountsCountChipRenderer;
